import { Button } from "@southfields-digital/mxmz-react-ui";
import classNames from "classnames";

import type { HockeyContestant } from "src/types/matchControl/contestant";

import styles from "../../MatchControl.module.scss";

type VideoReferralButtonProps = {
	contestant: HockeyContestant;
	onToggle: () => void;
};

type VideoReferralProps = {
	home: HockeyContestant;
	away: HockeyContestant;
	handleVideoReferral: (contestant: HockeyContestant, value: boolean) => void;
};

const VideoReferralButton = ({ contestant, onToggle }: VideoReferralButtonProps) => (
	<Button
		className={classNames(
			"flex items-center justify-center px-3 h-9 text-sm font-semibold rounded uppercase",
			contestant.videoReferral ? styles.VideoReferralEnabled : styles.VideoReferralDisabled,
		)}
		onClick={onToggle}
	>
		Video Ref
	</Button>
);

const VideoReferralComponent = ({ home, away, handleVideoReferral }: VideoReferralProps) => {
	const handleToggle = (contestant: HockeyContestant) => {
		handleVideoReferral(contestant, !contestant.videoReferral);
	};

	return (
		<div className={styles.ItemWrapper}>
			<div className={styles.CurrentCardWrapper}>
				{[home, away].map((contestant) => (
					<div key={contestant.id} className={styles.HockeyCardWrapper}>
						<VideoReferralButton
							contestant={contestant}
							onToggle={() => handleToggle(contestant)}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default VideoReferralComponent;
